import React, { Component } from 'react';
import PropTypes from 'prop-types';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_backdrop__3xuAW {\n  background: black;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: none;\n  opacity: 0;\n  z-index: 50;\n  will-change: opacity;\n  touch-action: none;\n}\n\n.styles_visible__3TqW5 {\n  display: block;\n}\n\n.styles_sidenav__35_7Q {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 100;\n  overflow: auto;\n  will-change: transform;\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.6);\n  background: white;\n}\n\n.styles_content__1Phom {\n  position: relative;\n  z-index: 10;\n}\n\n.styles_noOverflow___X-YP {\n  overflow: hidden;\n}\n";
var styles = {
  "backdrop": "styles_backdrop__3xuAW",
  "visible": "styles_visible__3TqW5",
  "sidenav": "styles_sidenav__35_7Q",
  "content": "styles_content__1Phom",
  "noOverflow": "styles_noOverflow___X-YP"
};
styleInject(css);
var requestAnimationFrame = window.requestAnimationFrame;
var doc = window.document;

var Sidenav =
/*#__PURE__*/
function (_Component) {
  _inherits(Sidenav, _Component);

  function Sidenav(props) {
    var _this;

    _classCallCheck(this, Sidenav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sidenav).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "touchstart", function (e) {
      var transform = _this.state.transform;
      var open = _this.props.open;

      if (_this.animation.fingerId !== null) {
        // already touching it with another finger :D
        e.preventDefault();
        return;
      }

      if (e.touches.length !== 1) {
        // touching with multiple fingers
        return;
      } // if closed, check if the touch is from the left edge of the screen


      if (!open && e.touches[0].clientX > _this.options.dragStartSensitivity) {
        return;
      }

      _this.animation.fingerId = e.touches[0].identifier;
      _this.animation.startX = e.touches[0].clientX;
      _this.animation.startY = e.touches[0].clientY;
      _this.animation.startTransform = transform;
      _this.animation.wasInSidenavOnce = false;
      _this.animation.draggingStarted = false;
      _this.animation.previousX = -999;
      _this.animation.previousY = -999; // bind touchmove and end cancel events

      doc.addEventListener('touchmove', _this.touchmove, {
        passive: true
      });
      doc.addEventListener('touchcancel', _this.touchfinish, {
        passive: true
      });
      doc.addEventListener('touchend', _this.touchfinish, {
        passive: true
      });

      _this.setTouchState(true);
    });

    _defineProperty(_assertThisInitialized(_this), "touchmove", function (e) {
      var pivotTouch = _toConsumableArray(e.changedTouches).find(function (t) {
        return _this.animation.fingerId === t.identifier;
      }); // our finger that starting dragging on screen is not on the screen anymore


      if (!pivotTouch) {
        return;
      }

      if (Math.abs(pivotTouch.clientX - _this.animation.previousX) < 1 && Math.abs(pivotTouch.clientY - _this.animation.previousY) < 1) {
        // Do not over invoke move event
        return;
      }

      _this.animation.lastSpeed = pivotTouch.clientX - _this.animation.previousX;
      _this.animation.previousX = pivotTouch.clientX;
      _this.animation.previousY = pivotTouch.clientY;

      if (_this.props.open) {
        if (!_this.animation.draggingStarted && Math.abs(_this.animation.startX - pivotTouch.clientX) < Math.abs(_this.animation.startY - pivotTouch.clientY)) {
          // we are scrolling on Y axis in the sidenav. we shall not move it.
          _this.doTouchFinish(null);

          return;
        }
      }

      _this.animation.draggingStarted = true;

      _this.expandTo(_this.animation.startTransform + (pivotTouch.clientX - Math.min(_this.animation.startX, _this.options.width)));
    });

    _defineProperty(_assertThisInitialized(_this), "touchfinish", function (e) {
      var pivotTouch = _toConsumableArray(e.changedTouches).find(function (t) {
        return _this.animation.fingerId === t.identifier;
      }); // our finger that starting dragging on screen is not on the screen anymore


      if (!pivotTouch) {
        return;
      }

      if (!_this.animation.draggingStarted) {
        return _this.doTouchFinish(null);
      }

      var shouldOpen = _this.state.transform > _this.options.width / 2;

      if (_this.animation.lastSpeed > _this.options.swipeSensitivity) {
        shouldOpen = true;
      } else if (_this.animation.lastSpeed < -1 * _this.options.swipeSensitivity) {
        shouldOpen = false;
      }

      _this.doTouchFinish(shouldOpen);
    });

    _defineProperty(_assertThisInitialized(_this), "doTouchFinish", function (shouldOpen) {
      if (shouldOpen === true) {
        _this.open();
      } else if (shouldOpen === false) {
        _this.close();
      }

      doc.removeEventListener('touchmove', _this.touchmove);
      doc.removeEventListener('touchcancel', _this.touchfinish);
      doc.removeEventListener('touchend', _this.touchstart);
      _this.animation.fingerId = null;

      _this.setTouchState(false);
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.setState(function (prevState) {
        return {
          backdropClass: _objectSpread2({}, prevState.backdropClass, _defineProperty({}, styles.visible, true))
        };
      });

      doc.body.classList.add(styles.noOverflow);
      var _this$state = _this.state,
          startTransform = _this$state.transform,
          startOpacity = _this$state.backdropOpacity;
      var _this$options = _this.options,
          fullAnimationDuration = _this$options.animationDuration,
          width = _this$options.width,
          backdropOpacity = _this$options.backdropOpacity,
          extraClosePixels = _this$options.extraClosePixels;
      var animationDuration = (width - startTransform) * fullAnimationDuration / (width + extraClosePixels); // if the speed caused a swipe, we adjust our animation speed to match swipe's momentum

      if (_this.animation.lastSpeed > _this.options.swipeSensitivity) {
        animationDuration = _this.options.defaultAnimationSensitivity * animationDuration / _this.animation.lastSpeed;
      }

      var transformAnimationFn = function transformAnimationFn(currentTime) {
        return Sidenav.easeOutQuad(currentTime, startTransform, width, animationDuration);
      };

      var opacityAnimationFn = function opacityAnimationFn(currentTime) {
        return Sidenav.easeOutQuad(currentTime, startOpacity, backdropOpacity, animationDuration);
      };

      var onAnimationEnd = function onAnimationEnd() {
        _this.setBusyState(false);

        _this.props.onSetOpen(true);
      };

      _this.animateSidebar(animationDuration, transformAnimationFn, opacityAnimationFn, onAnimationEnd);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var _this$state2 = _this.state,
          startTransform = _this$state2.transform,
          startOpacity = _this$state2.backdropOpacity;
      var _this$options2 = _this.options,
          fullAnimationDuration = _this$options2.animationDuration,
          extraClosePixels = _this$options2.extraClosePixels,
          width = _this$options2.width;
      var animationDuration = (startTransform + extraClosePixels) * fullAnimationDuration / (width + extraClosePixels); // if the speed caused a swipe, we adjust our animation speed to match swipe's momentum

      if (Math.abs(_this.animation.lastSpeed) > _this.options.swipeSensitivity) {
        animationDuration = _this.options.defaultAnimationSensitivity * animationDuration / Math.abs(_this.animation.lastSpeed);
      }

      var transformAnimationFn = function transformAnimationFn(currentTime) {
        return Sidenav.easeOutQuad(currentTime, startTransform, -1 * extraClosePixels, animationDuration);
      };

      var opacityAnimationFn = function opacityAnimationFn(currentTime) {
        return Sidenav.easeOutQuad(currentTime, startOpacity, 0, animationDuration);
      };

      var onAnimationEnd = function onAnimationEnd() {
        _this.setState(function (prevState) {
          return {
            backdropClass: _objectSpread2({}, prevState.backdropClass, _defineProperty({}, styles.visible, false))
          };
        });

        doc.body.classList.remove(styles.noOverflow);

        _this.setBusyState(false);

        _this.props.onSetOpen(false);
      };

      _this.animateSidebar(animationDuration, transformAnimationFn, opacityAnimationFn, onAnimationEnd);
    });

    _this.options = _objectSpread2({}, Sidenav.defaultOptions, {}, props.options || {});
    _this.state = {
      isTouched: false,
      sidenavStyle: _objectSpread2({}, _this.options.sidenavStyle),
      backdropStyle: _objectSpread2({}, _this.options.backdropStyle),
      backdropClass: _defineProperty({}, styles.backdrop, true),
      contentClass: _defineProperty({}, styles.content, true),
      transform: 0,
      backdropOpacity: 0
    };
    _this.animation = {
      fingerId: null,
      startX: null,
      startY: null,
      draggingStarted: false,
      previousX: null,
      previousY: null,
      wasInSidenavOnce: false,
      lastAnimationId: 0,
      lastSpeed: 0
    };
    _this.sidenavRef = React.createRef();
    return _this;
  }

  _createClass(Sidenav, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        if (this.props.open) {
          this.open();
        } else {
          this.close();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.options.width) {
        this.options.width = this.sidenavRef.current.offsetWidth;
      }

      this.setState({
        transform: -1 * this.options.extraClosePixels
      });
      this.registerEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deregisterEvents();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      doc.addEventListener('touchstart', this.touchstart, {
        passive: false
      });
    }
  }, {
    key: "deregisterEvents",
    value: function deregisterEvents() {
      doc.removeEventListener('touchstart', this.touchstart);
    }
  }, {
    key: "expandTo",
    value: function expandTo(px) {
      px = Math.min(px, this.options.width);
      var opacity = this.options.backdropOpacity * px / this.options.width;
      this.setState(function (prevState) {
        return {
          backdropClass: _objectSpread2({}, prevState.backdropClass, _defineProperty({}, styles.visible, true)),
          transform: px,
          backdropOpacity: opacity
        };
      });
      doc.body.classList.add(styles.noOverflow);
    }
  }, {
    key: "getTransformXStyle",
    value: function getTransformXStyle(px) {
      var width = this.options.width;
      return {
        transform: "translate3d(".concat(px - width, "px, 0, 0)")
      };
    }
  }, {
    key: "getOpacityStyle",
    value: function getOpacityStyle(opacity) {
      return {
        opacity: opacity
      };
    }
  }, {
    key: "setBusyState",
    value: function setBusyState(isBusy) {
      if (this.props.onSetBusy) {
        this.props.onSetBusy(isBusy);
      }
    }
  }, {
    key: "setTouchState",
    value: function setTouchState(isTouched) {
      if (this.props.onTouch) {
        this.props.onTouch(isTouched);
      }
    }
  }, {
    key: "animateSidebar",
    value: function animateSidebar(animationDuration, transformAnimationFn, opacityAnimationFn, onAnimationEnd) {
      var _this2 = this;

      var lastAnimationId = this.animation.lastAnimationId;
      var animationStartTime = null;
      var animationId = lastAnimationId + 1;
      this.animation.lastAnimationId = animationId;
      this.setBusyState(true);

      var animate = function animate(time) {
        if (animationId !== _this2.animation.lastAnimationId) {
          // looks like a new animation triggered while this was in progress... ignore this one.
          return;
        }

        if (animationDuration === 0) {
          // nothing to animate, just finish it already
          onAnimationEnd();
          return;
        }

        var timePassed = 0;

        if (animationStartTime === null) {
          animationStartTime = time;
        } else {
          timePassed = Math.min(time - animationStartTime, animationDuration);
        }

        var targetOpacity = opacityAnimationFn(timePassed);
        var targetTransform = transformAnimationFn(timePassed);

        _this2.setState({
          transform: targetTransform,
          backdropOpacity: targetOpacity
        });

        if (timePassed < animationDuration) {
          requestAnimationFrame(animate);
        } else {
          onAnimationEnd();
        }
      };

      requestAnimationFrame(animate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sidenav = _this$props.sidenav,
          children = _this$props.children,
          onSetOpen = _this$props.onSetOpen;
      var _this$state3 = this.state,
          sidenavStyle = _this$state3.sidenavStyle,
          backdropStyle = _this$state3.backdropStyle,
          backdropClass = _this$state3.backdropClass,
          contentClass = _this$state3.contentClass,
          transform = _this$state3.transform,
          backdropOpacity = _this$state3.backdropOpacity;
      var _this$options3 = this.options,
          extraSidenavClass = _this$options3.sidenavClass,
          contentStyle = _this$options3.contentStyle;
      var backdropOpacityStyle = this.getOpacityStyle(backdropOpacity);
      var transformStyle = this.getTransformXStyle(transform);
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: Sidenav.className(backdropClass),
        style: _objectSpread2({}, backdropStyle, {}, backdropOpacityStyle),
        onClick: function onClick() {
          return onSetOpen(false);
        }
      }), React.createElement("div", {
        className: Sidenav.className(styles.sidenav, extraSidenavClass),
        style: _objectSpread2({}, sidenavStyle, {}, transformStyle),
        ref: this.sidenavRef
      }, sidenav), React.createElement("div", {
        className: Sidenav.className(contentClass),
        style: contentStyle
      }, children));
    }
  }], [{
    key: "className",
    value: function className() {
      for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
        classNames[_key] = arguments[_key];
      }

      var normalizedClassList = classNames.reduce(function (acc, cn) {
        if (Array.isArray(cn)) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(cn));
        }

        if (typeof cn === 'string') {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(cn.split(' ')));
        }

        if (_typeof(cn) === 'object') {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(Object.keys(cn).reduce(function (acc, k) {
            if (cn[k]) {
              return [].concat(_toConsumableArray(acc), [k]);
            }

            return acc;
          }, [])));
        }

        return acc;
      }, []);
      return _toConsumableArray(new Set(normalizedClassList)).join(' ');
    }
  }, {
    key: "easeOutQuad",
    value: function easeOutQuad(currentTime, startValue, endValue, animationDuration) {
      endValue = endValue - startValue;
      currentTime /= animationDuration;
      return -endValue * currentTime * (currentTime - 2) + startValue;
    }
  }]);

  return Sidenav;
}(Component);

_defineProperty(Sidenav, "propTypes", {
  sidenav: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  onSetOpen: PropTypes.func.isRequired,
  onSetBusy: PropTypes.func,
  onTouch: PropTypes.func,
  options: PropTypes.shape({
    extraClosePixels: PropTypes.number,
    width: PropTypes.number,
    backdropOpacity: PropTypes.number,
    animationDuration: PropTypes.number,
    sidenavClass: PropTypes.string,
    sidenavStyle: PropTypes.object,
    backdropStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    dragStartSensitivity: PropTypes.number,
    swipeSensitivity: PropTypes.number,
    defaultAnimationSensitivity: PropTypes.number
  })
});

_defineProperty(Sidenav, "defaultOptions", {
  extraClosePixels: 30,
  backdropOpacity: 0.5,
  animationDuration: 300,
  sidenavClass: '',
  sidenavStyle: {},
  backdropStyle: {},
  contentStyle: {},
  dragStartSensitivity: 40,
  swipeSensitivity: 10,
  defaultAnimationSensitivity: 40
});

export default Sidenav;